<template>
  <div class="sound">
    <div style="margin-bottom: 5px;">
      <NewSoundFeature></NewSoundFeature>
    </div>
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <audio
        id="listen-audio"
        style="display: none"
        :src="$handleAssetsUrl(testBGM.url)"
        controls
        :volume="BGM.url ? BGM.volume : 50"
      ></audio>
      <audio
        id="bgm-audio"
        style="display: none"
        :src="$handleAssetsUrl(BGM.url)"
        controls
        :volume="BGM.url ? BGM.volume : 50"
      ></audio>

      <div class="soundTopBox">
        <div
          class="soundBtn"
          @click="
            uploadFs('audio', $event);
            materialPushAnalysis({ type: 'soundBtnSetaudio' });
          "
        >
          <i></i>
          <span>录音</span>
        </div>
        <el-tooltip placement="left" :open-delay="100">
          <div
            slot="content"
            class="tooltip-content"
            style="max-width: 180px; padding-bottom: 8px"
          >
            <a href="/vip">
              您可选择任一首付费音乐作为背景音乐，并使用兑换券减免所有费用，
              <span style="border-bottom: 1px solid #fff; cursor: pointer"
                >开通会员获取音乐兑换券</span
              >
            </a>
          </div>
          <div class="soundBtn">
            <span
              >我的音乐券{{ soundCoupon > 0 ? " * " + soundCoupon : "" }}</span
            >
          </div>
        </el-tooltip>
      </div>

      <div class="cate-munu-wrapper" style="padding-top: 15px">
        <cate-menu
          :options="category"
          :selectedIndex="selectedCateIndex"
          @clickItem="getCategoryList"
        ></cate-menu>
      </div>

      <div class="menu-wrapper" v-show="slideState && dataMsg == 'sound'">
        <div class="backdrop">
          <i @click="backToTop()"></i>
        </div>
        <DropDownMenu
          :options="previewData"
          :selectedIndex="selectedDurationIndex"
          all="全部时长"
          @clickItem="selectDuration"
        ></DropDownMenu>
      </div>

      <!-- v-for="(item, index) in category"
      :key="item.id"
      :class="{'operation': dataArray['_' + item.id].judge}"
      :style="{'height': dataArray['_' + item.id].judge ? 'auto' : '142px' }"
      -->
      <div class="data-body" style="overflow: visible">
        <div
          class="body-list"
          v-if="dataArray && dataArray.sound && dataArray.sound.data"
          :style="{
            width: '270px',
            height: dataArray.sound.data.length
              ? scollTop.material * dataArray.sound.data.length +
                80 +
                100 +
                'px'
              : '200px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top': dataArray.sound.data.length
              ? scollTop.material * dataArray.sound.data.length - 10 + 'px'
              : '50px',
            'min-height': '270px',
          }"
        >
          <div
            class="item"
            v-for="(itemL, indexL) in dataArray.sound.data"
            :key="indexL"
            :style="{
              backgroundColor: BGM.resourceId === itemL.id ? '#e7e7fb' : '',
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <!-- 播放 -->
            <div class="playGrid">
              <el-tooltip
                effect="dark"
                content="试听"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  :class="
                    testBGM.resourceId === itemL.id && testBGM.loading
                      ? 'el-icon-loading'
                      : testBGM.resourceId === itemL.id && !testBGM.paused
                      ? 'stop'
                      : 'play'
                  "
                  style="margin: 0"
                  @click="play(itemL)"
                ></span>
              </el-tooltip>
            </div>
            <!--  -->
            <div class="detailGrid">
              <el-tooltip
                effect="dark"
                :content="itemL.title"
                placement="left"
                :open-delay="1000"
              >
                <p class="name">{{ itemL.title }}</p>
              </el-tooltip>
              <p class="duration">{{ itemL.duration | formatTime }}</p>
            </div>
            <div class="infoGrid">
              <div class="staticGrid">
                <div class="logoGrid">
                  <company :itemData="itemL" :boxName="boxName" />
                </div>
                <div class="payGrid">
                  <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
                  <payType-subscript :item="itemL"></payType-subscript>
                </div>
              </div>

              <div class="selectedGrid">
                <el-tooltip
                  effect="dark"
                  content="收藏"
                  placement="top"
                  :open-delay="1000"
                >
                  <i
                    class="collection_sprite_icon"
                    :class="[
                      { collection_sprite_icon_active: itemL.favorites },
                      'vipResource_' + itemL.id,
                    ]"
                    style="
                      display: inline-block;
                      position: relative;
                      right: 0;
                      top: 0;
                    "
                    @mouseover="
                      collectionSpriteIconTit($event);
                      stopDocument($event);
                    "
                    @click="
                      stopDocument($event);
                      collectionSpriteIconFS(itemL, $event);
                    "
                  ></i>
                </el-tooltip>

                <el-tooltip
                  effect="dark"
                  content="使用"
                  placement="bottom"
                  :open-delay="1000"
                >
                  <span
                    :class="
                      BGM.resourceId === itemL.id ? 'select-active' : 'select'
                    "
                    @click="
                      setMusic(itemL);
                      materialPushAnalysis({
                        type: 'music',
                        id: itemL.id,
                        name: itemL.name,
                      });
                    "
                    style="margin: 0 10px"
                  ></span>
                </el-tooltip>
              </div>
            </div>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 50px"
          ></div>

          <div class="more-sound" v-show="slideState && dataMsg == 'sound'">
            <div class="btn" @click="callSpriteLib()">更多声音</div>
          </div>
        </div>
      </div>

      <SwitchStyle />
      <!-- <CategoryPrompt
        v-model="fixTopId"
        :windowMove = 'windowMove'
        :judgeFixed = 'judgeFixed'
        :boxName    = 'boxName'
        :dataArray  = 'dataArray'
      />-->
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="setSound"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";
import CateMenu from "../controls/cateMenu";
import DropDownMenu from "../controls/menu";
import PayTypeSubscript from "@/components/common/payTypeSubscriptSmall";
import NewSoundFeature from '../newSoundFeature.vue';
import addSound from './addSound.js';

export default {
  mixins: [rightnavSlide, Analysis, addSound],
  data() {
    return {
      activeIndex: "",
      showTitleInput: false,
      listenAudio: "", // audio标签
      bgmAudio: "", // 单独为背景音乐时长设置的
      timer: "",
      currentTime: 0, // 试听音乐进度
      newTitle: "", // 修改音乐标题时暂存字段
      BGM: {
        url: "",
        title: "",
        duration: 0,
        isLoop: true,
        volume: 50,
      },
      testBGM: {}, // 试听音乐
      isLoaded: false, //  音乐是否加载完成
      boxName: "sound", // 素材盒子的名字
      dataArray: [], // 数据数组
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 5,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      scollTop: {
        // 控制滚动条的数据
        default: 75, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 65, // 单个元素的高度
        rowNum: 1, // 每行个数
      },
      user: true, // 判断是否含有user块
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 1, // 瀑布流的列数
      },
      previewData: [
        {
          name: "30s以内",
          data: "0,30",
          // type : 'static',
        },
        {
          name: "31-60s",
          data: "31,60",
          // type : 'dynamic'
        },
        {
          name: "1分钟-2分钟",
          data: "60,120",
        },
        {
          name: "2分钟-3分钟",
          data: "120,180",
        },
        {
          name: "3分钟以上",
          data: "180,600",
        },
      ],
      selectedDurationIndex: -1,
      selectedCateIndex: -1,
      soundCoupon: 0,
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "Tool_Size",
      "MaterialPane_Size",
      // "RightNavTopPartHeight",
      "SetPanel_Size",
      "SelectScenes_Msg",
      "TOOL",
      "Window_Size",
      "StyleMsg",
      "S_SearchName",
    ]),
    ...mapGetters({
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr'
    })
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatTime(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
  },
  watch: {
    BGM: {
      deep: true,
      handler(val, oldVal) {
        if (!this.listenAudio) {
          this.listenAudio = document.getElementById("listen-audio");
        }
        if (!val.url) return;
        this.listenAudio.volume = val.volume / 100;
        this.bgmAudio.oncanplay = () => {
          this.BGM.duration = this.bgmAudio.duration;
        };
        this.setSound(val);
      },
    },
    "TOOL.sound"(val) {
      let soundData = this.TOOL.getSound();
      if (!soundData) return;
      if (
        soundData.resourceId === this.BGM.resourceId &&
        this.BGM.volume === soundData.volume &&
        this.BGM.isLoop === soundData.isLoop
      )
        return;
      this.BGM.resourceId = soundData.resourceId;
      this.BGM.title = soundData.title;
      this.BGM.url = this.$handleAssetsUrl(soundData.url);
      this.BGM.fileType = soundData.fileType;
      this.BGM.volume = (soundData.volume > 100 ? 50 : soundData.volume) || 50;
      this.BGM.subtitle = soundData.subtitle;
      this.BGM.isLoop = soundData.isLoop;
    },
    dataMsg(val) {
      if (val === "sound") {
        this.handleMenuPosition();
      }
      if (val !== "sound") {
        // 停止试听
        this.stop();
      }
    },
    slideState(val) {
      if (!val) {
        this.stop();
      } else {
        let music = this.TOOL.getSound() || {};
        this.BGM.resourceId = music.resourceId;
        this.BGM.title = music.title;
        this.BGM.url = this.$handleAssetsUrl(music.url);
        this.BGM.fileType = music.fileType;
        this.BGM.volume = music.volume || 50;
        this.BGM.subtitle = music.subtitle;
        this.BGM.isLoop = music.isLoop || true;
      }
    },
    S_SearchName: function (val, oldval) {
      // 关键词搜索事件
      this.stop();
    },
    "testBGM.paused": function (val, oldval) {
      // 关键词搜索事件
      if (this.testBGM.paused) {
        this.$bus.emit("search_listen_BGM", this.testBGM.paused);
      }
    },
    "MaterialPane_Size.width": {
      handler(val) {
        if (val > 95) {
          this.getSoundCoupon();
        }
      },
    },
  },
  created() {
    this.$bus.on("payPriceEvent_vue", () => {
      this.getSoundCoupon();
    });
    this.$bus.on("rightSlideBox_vue", (data) => {
      if (data.type === "sound") {
        this.getSoundCoupon();
      }
    });
  },
  mounted() {
    this.listenAudio = document.getElementById("listen-audio");
    this.bgmAudio = document.getElementById("bgm-audio");
    this.$bus.on("upload_vue", (data) => {
      // 上传完成的发出事件
      if (data.type === "audio" && data.name === "music") {
        this.materialPushAnalysis({ type: "musicBgUpload" });
        let scenesData = {};

        scenesData.url = data.data.filename;
        scenesData.title = data.file.name;
        scenesData.duration = data.file.duration;
        document.getElementById("music").value = document.getElementById(
          "load-music"
        ).value = "";

        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "在这里可以看到上传的背景音乐。",
          position: {
            top: "250px",
            left: `${this.MaterialPane_Size.width + 15}px`,
          },
        });

        this.$http
          .post("/api/user/music", scenesData)
          .then((res) => {
            let audio = res.data.data;
            let fixed = (audio.size / 1024 / 1024).toFixed(4);
            sensors.track("materialUpload", {
              material_id: audio.id,
              material_type: "音频",
              material_size: fixed,
            });
            this.$bus.emit("collectPersonal_vue", { data: "collectMusic" });
            // 上传完成自动添加到背景音乐
            this.$http
              .get("/api/user/music?sOfPage=1&fPage=1&pIndex=1")
              .then((res) => {
                // this.pickMusic({...res.data.data[0], trackingType: '1100'});
                // this.showVolume();
                this.setMusic({...res.data.data[0], trackingType: '1100'});
              });

            this.$bus.emit("relateMaterialDone", {
              materials: [].concat(audio),
              materialTypeName: "music",
              multi: false,
            });
          })
          .catch((Serror) => {});

        this.$bus.emit("upDataUserMsg_vue", data);
      } else if (data.type === "audio" && data.name === "audio") {
        this.materialPushAnalysis({ type: "musicRecordUpload" });
        let scenesData = {};

        scenesData.url = data.data.filename;
        scenesData.title = data.file.name;
        scenesData.duration = data.file.duration;
        scenesData.musicType = 1;

        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "在这里可以看到上传的录音。",
          position: {
            top: "250px",
            left: `${this.MaterialPane_Size.width + 15}px`,
          },
        });

        this.$http
          .post("/api/user/music", scenesData) // 收藏scenes
          .then((res) => {
            let audio = res.data.data;
            let fixed = (audio.size / 1024 / 1024).toFixed(4);
            sensors.track("materialUpload", {
              material_id: audio.id,
              material_type: "音频",
              material_size: fixed,
            });
            this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });
            this.$bus.emit("collectPersonal_vue", { data: "audio" });

            // 上传完成自动添加到当前页面
          })
          .catch((Serror) => {});

        this.$bus.emit("upDataUserMsg_vue", data);
      }
    });
    this.$bus.on("setting-BGM-vol", (data) => {
      this.BGM.volume = data;
    });
    this.$bus.on("stop_listen_BGM", () => {
      this.stop();
    });
    this.$bus.on("start_listen_BGM", (music) => {
      this.play(music);
    });
    this.$bus.on("addAudioToScene", this.addAudioToScene);
    this.$bus.on("addAudioToGlobal", this.addAudioToGlobal);

    this.$bus.on("rightSlideBoxBroadcast_vue", this.handleMenuPosition);
    $(window).on("scroll", this.handleMenuPosition);
  },
  methods: {
    getSoundById(resourceId) {
      this.$http
        .get("/api/common/material?type=5&id=" + resourceId)
        .then((res) => {
          if (res.data.data) {
            this.BGM.title = res.data.data.title || "未命名";
            this.BGM.duration = res.data.data.duration || 0;
          } else {
            this.$http
              .get(
                "/api/user/music?sOfPage=24&fPage=24&pIndex=1&type=5&musicType=0&id=" +
                  resourceId
              )
              .then((res) => {
                this.BGM.title = res.data.data.title || "未命名";
                this.BGM.duration = res.data.data.duration || 0;
              });
          }
        });
    },
    updateTitle(item) {
      this.showTitleInput = false;
      this.activeIndex = "";
      if (!this.newTitle.trim()) return;
      this.$http
        .put("/api/user/music/" + item.id, {
          title: this.newTitle.slice(0, 50),
        })
        .then((res) => {
          if (res.status === 200) {
            // 修改成功
          }
        });
      item.title = this.newTitle.slice(0, 50);
      this.newTitle = "";
      this.$store.commit("toggle_isPreventDefault", true);
    },
    editTitle(item, index, e) {
      this.$store.commit("toggle_isPreventDefault", false);
      this.newTitle = item.title;
      this.showTitleInput = true;
      this.activeIndex = index;
      setTimeout(() => {
        e.target.parentElement.children[1].focus();
      });
    },
    unsetSound() {
      this.testBGM = {};
      this.BGM = {
        resourceId: "",
        title: "",
        fileType: null,
        url: "",
        duration: 0,
        isLoop: true,
        volume: 50,
      };
      this.TOOL.setSound(
        {
          // 添加全局bgm
          resourceId: "", // 资源id 用于查询资源的信息，下同
          title: "",
          fileType: null,
          url: "", // 资源路径
          isLoop: this.BGM.isLoop, // 是否循环
          volume: 50, // 音量0-100
          subtitle: null, // 字幕（预留字段）
        },
        true
      );
    },
    loadMusic(music) {
      const vm = this;
      // 加载音乐
      this.testBGM.paused = true;
      if (
        this.$handleAssetsUrl(music.url) ===
        this.$handleAssetsUrl(this.testBGM.url)
      ) {
        return Promise.resolve();
      }
      this.timer = clearInterval(this.timer);
      this.testBGM = Object.assign({}, this.testBGM, music);
      this.testBGM.url = this.$handleAssetsUrl(this.testBGM.url);
      this.testBGM.resourceId = music.id || music.resourceId;
      this.testBGM.loading = true;
      this.currentTime = 0;
      return new Promise((resolve, reject) => {
        this.isLoaded = false;
        this.listenAudio.oncanplaythrough = () => {
          vm.testBGM.loading = false;
          vm.$set(vm.testBGM, "loading", false);
          vm.testBGM = {
            ...vm.testBGM,
          };
          vm.isLoaded = true;
          resolve(vm.isLoaded);
        };

        this.listenAudio.onerror = function () {
          reject("加载音频出错");
        };
      });
    },
    stop() {
      // 停止试听
      this.listenAudio && this.listenAudio.pause();
      this.currentTime = (this.listenAudio || {}).currentTime = 0;
      this.timer = clearInterval(this.timer);
      this.testBGM.paused = true;
    },
    play(music) {
      this.listenAudio.removeEventListener("ended", this.endPlay);
      this.listenAudio.addEventListener("ended", this.endPlay);
      // 试听音乐的播放/暂停
      if (
        !this.isLoaded ||
        this.$handleAssetsUrl(music.url) !==
          this.$handleAssetsUrl(this.testBGM.url)
      ) {
        this.loadMusic(music).then((res) => {
          if (this.isLoaded && this.listenAudio.paused) {
            this.listenAudio.play();
            this.testBGM.paused = false;
            if (
              this.$handleAssetsUrl(this.BGM.url) ===
              this.$handleAssetsUrl(this.testBGM.url)
            ) {
              this.timer = setInterval(() => {
                this.currentTime = this.listenAudio.currentTime;
              }, 100);
            }
          }
        });
      } else {
        if (this.isLoaded && !this.listenAudio.paused) {
          this.listenAudio.pause();
          this.testBGM.paused = true;
          this.currentTime = this.listenAudio.currentTime = 0;
          this.timer = clearInterval(this.timer);
        } else if (this.isLoaded && this.listenAudio.paused) {
          this.listenAudio.play();
          this.testBGM.paused = false;
          if (
            this.$handleAssetsUrl(this.BGM.url) ===
            this.$handleAssetsUrl(this.testBGM.url)
          ) {
            this.timer = setInterval(() => {
              this.currentTime = this.listenAudio.currentTime;
            }, 100);
          }
        }
      }
    },
    endPlay() {
      this.testBGM.paused = true;
      this.listenAudio.removeEventListener("ended", this.endPlay);
    },
    pickMusic(music) {
      this.BGM.duration = music.duration;
      this.BGM.resourceId = music.resourceId || music.id;
      this.BGM.title = music.title;
      this.BGM.url = this.$handleAssetsUrl(music.url);
      this.BGM.fileType = music.fileType;
      if (music.trackingType) {
        this.BGM.trackingType = music.trackingType;
      }
      this.testBGM = {};
      // 成功添加音乐后弹出气泡提示
      this.$bus.emit("showTips", {
        text:
          "已将该音乐添加至整个视频中，在这里可以看到当前添加的背景音乐，可剪辑音乐时长并对音量和循环操作进行设置。",
        position: {
          top: `${
            this.TopNav_Size.height + this.Tool_Size.height - 320 - 160
          }px`,
          right: `${this.SetPanel_Size.width + 15}px`,
        },
      });
    },
    setSound() {
      // 防止重复设置
      if (
        this.TOOL.sound &&
        this.TOOL.sound.resourceId === this.BGM.resourceId &&
        this.TOOL.sound.isLoop === this.BGM.isLoop &&
        this.TOOL.sound.volume === this.BGM.volume
      )
        return;
      let soundData = this.TOOL.getSound() || {};
      if (soundData.url !== this.$handleAssetsUrl(this.BGM.url)) {
        soundData.startTime = 0;
        soundData.endTime = 0;
      }

      soundData.resourceId = this.BGM.resourceId; // 资源id 用于查询资源的信息，下同
      soundData.title = this.BGM.title;
      soundData.fileType = this.BGM.fileType;
      soundData.url = this.$handleAssetsUrl(this.BGM.url); // 资源路径
      soundData.isLoop = this.BGM.isLoop; // 是否循环
      soundData.volume = this.BGM.volume; // 音量0-100
      soundData.subtitle = null; // 字幕（预留字段）
      soundData.trackingType = this.BGM.trackingType;
      // 添加背景音乐
      this.TOOL.setSound(soundData, true); // 添加全局bgm
      // this.$store.commit('save_bgm', this.BGM);
    },
    setSoundRecord(music) {
      // 设置全局录音
      this.TOOL.setSoundRecord(
        {
          trackingType: "1100",
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title,
        },
        "global",
        true
      );
    },
    setSceneSound(music) {
      // 设置当前场景音乐
      this.TOOL.selectedScenes.setSound(
        {
          trackingType: "1100",
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title,
        },
        true
      );

      // this.TOOL.soundRecordBackup[this.TOOL.selectedScenes.index] = this.TOOL.selectedScenes.getSound();
      let arr = this.TOOL.sprites.map((s) => s.getSound());
      this.TOOL.setSoundRecord(arr, "scene", true);
    },
    showVolume() {
      this.$bus.emit("FeaturesPop_vue", {
        name: "volume_adjust",
        posx: 0,
        posy: 0,
        type: 1,
        BGM: this.BGM,
      });
    },

    // 录音上传完成自动添加到当前页面
    addAudioToScene(audio) {
      if (audio) {
        //
        this.setSceneSound(audio);
        this.showVolume();
        this.$analysis({
          category: "add_recording",
          action: "click_add_recording_to_the_scene",
          label: "添加录音_添加至当前页面",
        });
        return;
      }
      this.$http
        .get("/api/user/music?sOfPage=1&fPage=1&pIndex=1&musicType=1")
        .then((res) => {
          this.setSceneSound(res.data.data[0]);
          this.showVolume();
        });
    },

    // 录音上传完成自动添加到全局
    addAudioToGlobal(audio) {
      if (audio) {
        //
        // this.pickMusic(audio);
        this.setSoundRecord(audio);
        this.showVolume();
        this.$analysis({
          category: "add_recording",
          action: "click_add_recording_to_the_video",
          label: "添加录音_添加至整个视频",
        });
        return;
      }
      this.$http
        .get("/api/user/music?sOfPage=1&fPage=1&pIndex=1&musicType=1")
        .then((res) => {
          // this.pickMusic(res.data.data[0]);
          this.setSoundRecord(res.data.data[0]);
          this.showVolume();
        });
    },

    uploadFs(data, el) {
      switch (data) {
        case "audio":
          this.$bus.emit("FeaturesPop_vue", {
            type: 1,
            name: "textToVoice",
            initialX: this.MaterialPane_Size.width,
            initialY: el.clientY,
            posx: this.MaterialPane_Size.width,
            posy: el.clientY,
          });
          break;
      }
    },

    getCategoryList(index) {
      if (index == null) {
        index = this.selectedCateIndex;
      }
      this.$set(this.dataArray.sound, "data", []);
      let cate = this.category[index] || {};
      this.materialLib_Nav_Param.category = cate.id; //记录分类id，打开模板素材库时需要使用
      this.selectedCateIndex = index;

      this.selectedDurationIndex = -1;
      delete this.dataSet.durationMin;
      delete this.dataSet.durationMax;

      this._getData(cate.id || "sound", 1);
    },

    selectDuration(index) {
      let cate = this.category[this.selectedCateIndex] || {};
      let data = this.previewData[index].data;
      let emitData = {
        fileType: data,
        boxName: this.boxName,
      };
      if (cate.id) {
        emitData.id = "_" + cate.id;
      } else {
        emitData.id = "sound";
      }
      this.selectedDurationIndex = index;
      this.$bus.emit("filterSpritesJudge", emitData);
    },

    handleMenuPosition() {
      let menuWrapper = $(this.$el).find(".menu-wrapper");
      let rect = menuWrapper[0].getBoundingClientRect();
      if (rect.x == 0 && rect.y == 0 && rect.width == 0 && rect.height == 0)
        return;
      let menu = menuWrapper.find(".menu");
      let backdrop = menuWrapper.find(".backdrop");
      let calcTop = 150 - document.documentElement.scrollTop;
      if (rect.top < 150) {
        menu.css({
          position: "fixed",
          top: calcTop + "px",
          left: "82px",
          width: "240px",
        });
        backdrop.css({
          position: "fixed",
          top: calcTop + "px",
          left: "82px",
        });
      } else {
        menu.css({
          position: "relative",
          top: 0,
          left: 0,
          width: "270px",
        });
        backdrop.css({
          position: "absolute",
          top: 0,
          left: 0,
        });
      }
    },
    backToTop() {
      this.$bus.emit("rightSlideBoxScrollTop_vue", {
        scrollTop: 0,
      });
    },
    getSoundCoupon() {
      this.$http
        .get("/api/user/coupon", {
          params: {
            type: 1,
            goodsType: 12,
          },
        })
        .then((res) => {
          this.soundCoupon = res.data.total || 0;
          this.$store.commit("save_soundCoupon", {
            num: this.soundCoupon,
          });
        })
        .catch((err) => console.warn(err));
    },
  },
  components: {
    Search,
    CateMenu,
    DropDownMenu,
    PayTypeSubscript,
    NewSoundFeature
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sound {
  width: 270px;
  .upload-sound,
  .add-sound {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 270px;
    margin-top: 17px;
    border-top: 2px solid #d4d4e7;
    .btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      height: 34px;
      background-color: #a3a6cd;
      border-radius: 17px;
      color: #fff;
      cursor: pointer;
      margin-top: 17px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #5778fb;
      }
    }
    .question {
      position: absolute;
      top: 23px;
      right: 24px;
      display: inline-block;
      width: 20px;
      height: 20px;
      color: #fff;
      border-radius: 50%;
      background-color: #a3a6cd;
      cursor: pointer;
    }
  }

  .soundTopBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    // padding-top: 20px;

    .soundBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 128px;
      // background-color: #ededf6;
      background-color: #f6f7fc;
      border-radius: 3px;
      text-align: left;
      line-height: 36px;
      color: #474261;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #dbdff0;
      }

      & > i {
        width: 14px;
        height: 20px;
        background-image: url(../../../../static/svg/right-nav-new/record-sound.svg);
        background-repeat: no-repeat;
        margin-right: 12px;
      }
    }
  }
  .data-body {
    padding: 17px 0 22px 0;
    height: 142px;
    overflow: hidden;

    .body-list {
      position: relative;
      top: -80px;
      width: 0px;
      height: 0;
      // pointer-events: none;
      // min-height: 88px;
      // border-top: 2px solid #d6d3d3;
      // &:before{
      //   content: '';
      //   position:  absolute;
      //   top: -6px;
      //   left: 0 ;
      //   right: 0;
      //   margin: 0 auto;
      //   width: 10px;
      //   height: 10px;
      //   background: #fff;
      //   transform:rotate(135deg);
      //   border-top: 2px solid #d6d3d3;
      //   border-right: 2px solid #d6d3d3;
      // }
      .item {
        display: flex;
        //flex-wrap: nowrap;
        flex-direction: row;
        //align-items: stretch;
        //padding: 5px;
        width: 270px;
        height: 60px;
        margin-top: 3px;
        border-radius: 3px;
        background-color: #fafafd;
        border-radius: 4px;
        border: solid 1px #dbdff0;
        position: absolute;
        align-items: center;
        overflow: hidden;

        &:hover {
          background-color: #dbdff0;

          .select,
          .edit,
          .select-active {
            display: inline-flex;
          }
          .select-active {
            background: url("../../../../static/svg/select-active.svg")
              no-repeat center;
          }
          .selectedGrid {
            display: flex;
          }
          .staticGrid {
            display: none;
            opacity: 0;
          }
        }
        .play,
        .stop,
        .el-icon-loading {
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
        }
        .el-icon-loading {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: default;
          margin: 0;
        }
        .play {
          background: url("../../../../static/svg/materialPane/music/play.svg")
            no-repeat center;
          // &:hover {
          //   background: url("../../../../static/svg/play-active.svg") no-repeat
          //     center;
          // }
        }
        .stop {
          background: url("../../../../static/svg/materialPane/music/pause.svg")
            no-repeat center;
          // &:hover {
          //   background: url("../../../../static/svg/stop-active.svg") no-repeat
          //     center;
          // }
        }
        div.detail {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          p.name {
            display: block;
            color: #474261;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            max-width: 130px;
          }
          p.duration {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #a5a7c6;
            text-align: left;
            font-size: 12px;
          }
        }
        .select,
        .edit,
        .select-active {
          display: none;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          cursor: pointer;
        }
        .select {
          margin: 0px;
          background: url("../../../../static/svg/select.svg") no-repeat center;
          &:hover {
            background: url("../../../../static/svg/select-active.svg")
              no-repeat center;
          }
        }
        .select-active {
          background: url("../../../../static/svg/select-active.svg") no-repeat
            center;
        }
        .edit {
          background: url("../../../../static/svg/edit.svg") no-repeat center;
          &:hover {
            background: url("../../../../static/svg/edit-active.svg") no-repeat
              center;
          }
        }

        .modify,
        .label {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .label {
          bottom: 40px;
          right: 2px;
        }
        .modify {
          width: 35px;
          height: 35px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.3s;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }

        .playGrid {
          width: 52px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .detailGrid {
          position: relative;
          flex-grow: 1;
          //background-color: red;
          height: 100%;
          width: 137px;
          .name {
            position: absolute;
            display: block;
            color: #474261;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            max-width: 130px;
            top: 13px;
          }
          .duration {
            position: absolute;
            top: 35px;
            left: 0px;
            color: #a5a7c6;
            text-align: left;
            font-size: 12px;
          }
        }
        .infoGrid {
          position: relative;
          width: 81px;
          height: 100%;
          .staticGrid {
            position: absolute;
            right: 0;
            width: 63px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-end;
            padding-right: 10px;

            .logoGrid {
              margin-top: 10px;
              margin-bottom: 7px;
            }
            .payGrid {
              //position: absolute;
              //width: 100%;
              height: 14px;
              //left: -10px;
              // right: 0px;
              //top: 38px;
            }
          }
          .selectedGrid {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 0;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.menu-wrapper {
  position: relative;
  z-index: 300; // 挡住价格标签
  height: 38px;
  margin-top: 5px;
  & .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 270px;
    height: 38px;
    background-color: #fff;
    padding-bottom: 15px;
    box-sizing: content-box;

    & > i {
      width: 23px;
      height: 23px;
      background-image: url(../../../../static/svg/right-nav-new/close.svg);
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
}

@import "./slide.scss";
.more-sound {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  z-index: 300;
  width: 270px;
  height: 90px;
  text-align: center;
  pointer-events: none;
  & > .btn {
    @include bottom-more-btn();
    pointer-events: all;
  }
}
.tooltip-content a {
  text-decoration: none;
  color: #fff;
  &:visited {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/sound.vue